import { Injectable } from '@angular/core'

import { Observable, map } from 'rxjs'

import {
  AddEventHandlerResponse,
  EventHandlerApi,
} from '@flowx/designer/modules/ui-designer/components/config/event-handlers-config/event-handler-api.interface'
import { EventHandler } from '@flowx/designer/shared/types/event-handler.types'

import { ApiHttpProxyService, ForwardProxyMicroservice } from './api-http-proxy.service'

import { ApplicationResourceType, ProxyApiAction } from '../entities/application.entity'

@Injectable({
  providedIn: 'root',
})
export class EventHandlerApiService extends ApiHttpProxyService implements EventHandlerApi {
  #url = 'api/process'

  getEventHandlers(
    templateConfigId: number,
    resourceId: string | undefined,
    reusableUiTemplateContext?: string
  ): Observable<EventHandler[]> {
    void resourceId
    return this.get(
      `${this.#url}/templates/${templateConfigId}/actions/getAll`,
      {
        microservice:
          `with-ids-mappings/${ForwardProxyMicroservice.Admin}` as ForwardProxyMicroservice,
        resourceType: ApplicationResourceType.Process,
      },
      {
        params: {
          resourceTypesToIncludeMappingFor: 'reusable-template',
          ...(reusableUiTemplateContext ? { reusableUiTemplateContext } : {}),
        },
      }
    ).pipe(map((response) => response.resourceContent))
  }

  addEventHandler(
    templateConfigId: number,
    eventHandler: EventHandler,
    resourceId: string | undefined
  ): Observable<AddEventHandlerResponse> {
    void resourceId
    return this.patch(`${this.#url}/templates/${templateConfigId}/actions`, eventHandler, {
      microservice: ForwardProxyMicroservice.Admin,
      resourceType: ApplicationResourceType.Process,
      action: ProxyApiAction.CREATE,
    }).pipe(
      map((response) => ({
        action: response.resourceContent.action,
        reordered: response.resourceContent.reordered,
      }))
    )
  }

  updateEventHandler(eventHandler: EventHandler, resourceId: string | undefined): Observable<void> {
    void resourceId
    return this.patch(`${this.#url}/ui-actions`, eventHandler, {
      microservice: ForwardProxyMicroservice.Admin,
      resourceType: ApplicationResourceType.Process,
      action: ProxyApiAction.UPDATE,
    }).pipe(map((response) => response.resourceContent))
  }

  deleteEventHandler(
    eventHandlerId: number,
    resourceId: string | undefined
  ): Observable<Record<number, number> | undefined> {
    void resourceId
    return this.patch(`${this.#url}/ui-actions/${eventHandlerId}`, null, {
      microservice: ForwardProxyMicroservice.Admin,
      resourceType: ApplicationResourceType.Process,
      action: ProxyApiAction.DELETE,
    }).pipe(map((response) => response.resourceContent?.reordered))
  }

  reorderEventHandlers(
    templateConfigId: number,
    orderMap: Record<number, number>,
    resourceId: string | undefined
  ): Observable<Record<number, number>> {
    void resourceId
    return this.patch(`${this.#url}/templates/${templateConfigId}/actions/order/bulk`, orderMap, {
      microservice: ForwardProxyMicroservice.Admin,
      resourceType: ApplicationResourceType.Process,
      action: ProxyApiAction.PARTIAL_UPDATE,
    }).pipe(map((response) => response.resourceContent))
  }
}
